import React, { useState, useRef } from 'react'
import { Link, navigate } from 'gatsby'
import LogoIcon from '../assets/logo.jpeg'
import { useOnClickOutside } from '../hooks/useOnClickOutside'

import * as styles from './navigation.module.css'
import './styles/Navbar.css'

import FlyoutMenu from './FlyoutMenu'

const Navigation = () => {
  const ref = useRef(null)
  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false)

  const handleFlyoutToggle = (value) => {
    setIsFlyoutOpen(value)
  }

  return (
    <nav className="navigation__wrapper" role="navigation" aria-label="Main">
      <div className="navigation-container">
        <div className="navigation ">
          <img
            onClick={() => {
              navigate('/')
            }}
            className="navbar__logo"
            src={LogoIcon}
            alt="logo"
          />
          {isFlyoutOpen === false && (
            <i
              onClick={() => {
                handleFlyoutToggle(true)
              }}
              class="fas fa-bars flyout-toggler"
            ></i>
          )}
          <FlyoutMenu clickHandler={handleFlyoutToggle} isOpen={isFlyoutOpen} />
        </div>
      </div>
    </nav>
  )
}

export default Navigation
